import {initWebHomeRelatedProductsCarousel} from "./home-related-products-native";

window.initWebHomeRelatedProductsCarousel = initWebHomeRelatedProductsCarousel;
